import { POSTFORM, POST, GET } from '@/utils/request'
import Url from './url'
export const detail = async (params: object) => {
  return await GET({
    url: Url.detail,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
export const rule = async (params: object) => {
  return await GET({
    url: Url.rule,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
